export type PermissionGroup = {
  title: string;
  permissions: string[];
};

export const permissionsNames: string[] = [
  'Manage Shops',
  'Manage Products',
  'Product Categories',
  'Product Options',
  'Product Attributes',
  'Navigations',
  'Content Pages',
  'Custom Agree Types',
  'Content Block',
  'Language Labels',
  'FAQ Categories',
  'FAQ Management',
  'Filters',
  'Customers/Users',
  'Customer Order',
  'Cancel Reasons',
  'Extend Call-off requests',
  'Refund Upcharge Order',
  'Order Buffer Period',
  'Inventory Calendar',
  'Work Orders',
  'Discount Coupons',
  'Social Platforms Management',
  'General Settings',
  'QuickBooks Online',
  'Countries Management',
  'States Management',
  'Cities Management',
  'Manage Email Templates',
  'Theme Settings',
  'Currency Management',
  'Reports',
  'Sales Stats & Revenue Reporting - Dashboard',
  'Orders/Products List - Dashboard',
  'Bulk Import/Export',
  'Delivery Locations',
  'Staff Members',
  'Location Attributes',
  'Collectibles',
  'Accounting',
  'Credit Limit Adjustment',
  'Approve Purchase Orders',
  'Purchase Orders',
];

const permissionsGroup1: PermissionGroup[] = [
  {
    title: 'Shop Management',
    permissions: ['Manage Shops', 'Theme Settings', 'Social Platforms Management'],
  },
  {
    title: 'Product Management',
    permissions: ['Manage Products', 'Product Options', 'Product Categories', 'Product Attributes'],
  },
  {
    title: 'Content Management',
    permissions: [
      'Content Block',
      'Content Pages',
      'FAQ Management',
      'FAQ Categories',
      'Manage Email Templates',
      'Custom Agree Types',
      'Navigations',
      'Filters',
    ],
  },
  {
    title: 'Order Management',
    permissions: [
      'Customers/Users',
      'Customer Order',
      'Cancel Reasons',
      'Extend Call-off requests',
      'Refund Upcharge Order',
      'Order Buffer Period',
      'Collectibles',
      'Credit Limit Adjustment',
    ],
  },

  { title: 'Expense Management', permissions: ['Purchase Orders', 'Approve Purchase Orders'] },
];
const permissionsGroup2: PermissionGroup[] = [
  {
    title: 'Settings and Configurations',
    permissions: ['General Settings', 'Currency Management', 'QuickBooks Online'],
  },
  {
    title: 'Inventory Management',
    permissions: [
      'Inventory Calendar',
      'Bulk Import/Export',
      'Work Orders',
      'Location Attributes',
      'Cities Management',
      'Countries Management',
      'States Management',
    ],
  },
  {
    title: 'Shipping and Logistics',
    permissions: ['Delivery Locations'],
  },
  {
    title: 'Marketing and Promotions',
    permissions: ['Discount Coupons'],
  },
  {
    title: 'Reporting and Analytics',
    permissions: [
      'Reports',
      'Sales Stats & Revenue Reporting - Dashboard',
      'Orders/Products List - Dashboard',
      'Accounting',
    ],
  },
  {
    title: 'User Management',
    permissions: ['Staff Members'],
  },
  {
    title: 'Locations',
    permissions: ['Language Labels'],
  },
];

export const permissionsGroups: PermissionGroup[][] = [permissionsGroup1, permissionsGroup2];
